import { useState } from "react";
import { useHistory } from "react-router";
import { Card, CardBody, Col, Table, Button, Container, Row } from "reactstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TabPlusIcon from "mdi-react/TabPlusIcon";
import DepartmentKpiModal from "./DepartmentKpiModal";
import { decryption } from "@/containers/HelperFunctions";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_KPI_BY_DEPARTMENT_ID } from "@/GraphQL/Queries";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import { DELETE_DEPARTMENT_KPI } from "@/GraphQL/Mutation";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function DepartmentKpi() {
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const id = history?.location?.state?.dept;
  const { data, loading, error, refetch } = useQuery(
    GET_ALL_KPI_BY_DEPARTMENT_ID,
    {
      variables: { dept_id: Number(id) },
      skip: !Number(id),
    }
  );
  const [deleteDepartmentkpi, { loading: deleteLoading }] = useMutation(
    DELETE_DEPARTMENT_KPI
  );

  const [deleteDeptId, setDeleteDeptId] = useState(null);

  const toggle = () => setModal((prev) => !prev);

  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );

  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the KPI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const { data } = await deleteDepartmentkpi({ variables: { id } });
        if (data?.deleteDepartmentkpi?.status === "Success") {
          toast.success("KPI deleted successfully");
          refetch?.(); // Optional: refetch KPI list
        } else {
          toast.error("KPI not found or could not be deleted");
        }
      } catch (err) {
        toast.error("Error deleting KPI");
        console.error(err);
      }
    } else {
      toast.info("Deletion cancelled");
    }
  };
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Department List",
      link: "/department/list",
    },
    // {
    //   name: "Department",
    //   link: "department/list",
    // },
    // {
    //   name: updateUserInfo?.id ? "Update User" : "Create User",
    // },
  ];

  return (
    <div>
      <Row>
        <Col>
          <BreadCrumb breadCrumbData={breadCrumbData} />
        </Col>
      </Row>
      <Row className="px-3">
        <Col md={6} className="d-flex align-items-center">
          <h3 className="page-title mb-0">KPI List</h3>
        </Col>
        <Col md={6} className="d-flex justify-content-end align-items-center">
          {permissions?.includes("create_department") && (
            <Button
              onClick={() =>
                history.push({
                  pathname: "/department/kpi-create",
                  state: {
                    dept: id,
                  },
                })
              }
              // onClick={toggle}
              color="primary"
            >
              <TabPlusIcon className="mr-1" />
              Create KPI
            </Button>
            // <Button onClick={toggle} color="primary">
            //   <TabPlusIcon className="mr-1" />
            //   Create KPI
            // </Button>
          )}
        </Col>
      </Row>

      <Table role="table" striped hover responsive>
        <thead>
          <tr role="row">
            <th>#</th>
            <th>Key Area</th>
            <th>Department</th>
            <th>Description</th>
            <th>Weight</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.getAllKpiByDepartmentId.length ? (
            data?.getAllKpiByDepartmentId?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item?.key_area}</td>
                <td>{item?.department?.name}</td>
                <td>{item?.description}</td>
                <td>{item?.weight}</td>
                <td>
                  {permissions?.includes("delete_department") && (
                    <button
                      className="inbox__email-btn me-2"
                      type="button"
                      aria-label="delete"
                      onClick={() => deleteHandler(item.id)}
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  )}
                  {permissions?.includes("update_department") && (
                    <button
                      onClick={() =>
                        history.push({
                          pathname: "/department/kpi-create",
                          state: {
                            dept: id,
                            id: item?.id,
                          },
                        })
                      }
                      className="inbox__email-btn"
                      type="button"
                      aria-label="edit"
                    >
                      <EditIcon fontSize="small" />
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={12}
                className="text-center text-danger font-weight-bold"
              >
                Kpi not found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {modal && (
        <DepartmentKpiModal
          toggle={toggle}
          modal={modal}
          kpi_id={id}
          id={id}
          setModal={setModal}
        />
      )}
    </div>
  );
}
